import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { NavLink, useParams, useNavigate } from "react-router-dom";
import { baseurladdress } from "../baseurl";

const Swal = require('sweetalert2');

const showToast = (icon, message) => {
    Swal.fire({
        toast: true,
        position: 'top-end',
        icon,
        title: message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });
};

const getBranchId = (branch) => branch?.branch_id ?? branch?.branchid ?? null;
const getBranchCode = (branch) => branch?.branch_code ?? branch?.branchcode ?? '';
const getBranchName = (branch) => branch?.branch_name ?? branch?.branchname ?? '';

const branchSelectorStyles = {
    wrapper: {
        position: "relative"
    },
    trigger: {
        minHeight: "46px",
        border: "1px solid #d7deea",
        borderRadius: "4px",
        backgroundColor: "#ffffff",
        boxShadow: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 12px",
        cursor: "pointer"
    },
    triggerText: {
        fontSize: "0.98rem",
        color: "#52637d",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingRight: "12px"
    },
    triggerIcon: {
        fontSize: "0.9rem",
        color: "#70819b",
        flexShrink: 0
    },
    dropdown: {
        position: "absolute",
        top: "calc(100% + 8px)",
        left: 0,
        right: 0,
        zIndex: 20,
        border: "1px solid #d7deea",
        borderRadius: "4px",
        backgroundColor: "#ffffff",
        boxShadow: "0 8px 18px rgba(31, 45, 61, 0.12)",
        overflow: "hidden"
    },
    header: {
        display: "flex",
        alignItems: "center",
        padding: "10px 14px",
        background: "linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%)",
        borderBottom: "1px solid #e4ebf5"
    },
    headerText: {
        fontSize: "0.85rem",
        fontWeight: 600,
        color: "#4b5b76"
    },
    list: {
        maxHeight: "190px",
        overflowY: "auto",
        overflowX: "hidden",
        padding: "6px"
    },
    item: {
        display: "flex",
        alignItems: "flex-start",
        gap: "8px",
        padding: "6px 10px",
        marginBottom: "4px",
        borderRadius: "2px",
        cursor: "pointer",
        transition: "background-color 0.2s ease"
    },
    checkbox: {
        marginTop: "2px",
        width: "14px",
        height: "14px",
        accentColor: "#2f5bea",
        flexShrink: 0
    },
    label: {
        marginBottom: 0,
        fontSize: "0.92rem",
        fontWeight: 400,
        color: "#2f3b52",
        lineHeight: "1.2",
        wordBreak: "break-word"
    }
};


const EditLeavePolicy = () => {

    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");

    const { leavepolicy_num } = useParams();
    const navigate = useNavigate();

    const branchDropdownRef = useRef(null);

    const [leaveTypes, setLeaveTypes] = useState([]);
    const [leavepolices, setLeavepolices] = useState([]);

    const [branches, setBranches] = useState([]);

    const [selectedLeaves, setSelectedLeaves] = useState([]);

    const [policyno, setPolicyNo] = useState('');

    const [selectedBranchCodes, setSelectedBranchCodes] = useState([]);

    const [selectedLeaveId, setSelectedLeaveId] = useState('');

    const [loading, setLoading] = useState(true);

    const [isBranchDropdownOpen, setIsBranchDropdownOpen] = useState(false);

    const [staffList, setStaffList] = useState([]);
    const [branchList, setBranchList] = useState([]);

    // affected date states
    const [affectedFrom, setAffectedFrom] = useState('');
    const [affectedTo, setAffectedTo] = useState('');

    // levpo_flag: when checked, this policy applies to all staff
    const [levpoFlag, setLevpoFlag] = useState(false);
    const [submitting, setSubmitting] = useState(false);


    const groupedSelectedLeaves = selectedLeaves.reduce((acc, leave) => {
        if (!acc.some((item) => item.leaveid === leave.leaveid)) {
            acc.push(leave);
        }
        return acc;
    }, []);

    const getBranchTriggerText = () => {
        if (selectedBranchCodes.length === 0) {
            return "Choose Branch";
        }

        if (selectedBranchCodes.length === branches.length && branches.length > 0) {
            return "All Branches Selected";
        }

        const selectedNames = branches
            .filter((branch) => selectedBranchCodes.includes(getBranchCode(branch)))
            .map((branch) => getBranchName(branch));

        return selectedNames.join(", ");
    };

    const handleSelectAllBranches = (e) => {
        if (e.target.checked) {
            const existingPolicyLeaveTypes = Array.from(
                new Map(
                    selectedLeaves.map(leave => [
                        leave.leaveid,
                        {
                            leaveid: leave.leaveid,
                            leave_type: leave.leave_type,
                            max_leave: leave.max_leave
                        }
                    ])
                ).values()
            );

            const newLeaves = branches.flatMap(branch =>
                existingPolicyLeaveTypes
                    .filter(leave =>
                        !selectedLeaves.some(item =>
                            item.branchid === getBranchId(branch) &&
                            item.leaveid === leave.leaveid
                        )
                    )
                    .map(leave => ({
                        ...leave,
                        branchid: getBranchId(branch),
                        branchcode: getBranchCode(branch),
                        branchname: getBranchName(branch)
                    }))
            );

            if (newLeaves.length > 0) {
                setSelectedLeaves(prev => [...prev, ...newLeaves]);
            }

            setSelectedBranchCodes(branches.map(branch => getBranchCode(branch)).filter(Boolean));
            return;
        }
        setSelectedBranchCodes([]);


        // REMOVE ALL BRANCH DATA
        setSelectedLeaves([]);
    };

    const handleBranchCheckboxChange = (branchCode) => {
        const branch = branches.find(item => getBranchCode(item) === branchCode);

        if (!branch) return;

        const remove = selectedBranchCodes.includes(branchCode);

        if (remove) {

            setSelectedBranchCodes(prev =>
                prev.filter(code => code !== branchCode)
            );


            // REMOVE LEAVES OF THIS BRANCH ALSO
            setSelectedLeaves(prev =>
                prev.filter(item =>
                    item.branchcode !== branchCode
                )
            );


            return;
        }
        const existingPolicyLeaveTypes = Array.from(
            new Map(
                selectedLeaves.map(leave => [
                    leave.leaveid,
                    {
                        leaveid: leave.leaveid,
                        leave_type: leave.leave_type,
                        max_leave: leave.max_leave
                    }
                ])
            ).values()
        );

        const newBranchLeaves = existingPolicyLeaveTypes
            .filter(leave =>
                !selectedLeaves.some(item =>
                    item.branchid === getBranchId(branch) &&
                    item.leaveid === leave.leaveid
                )
            )
            .map(leave => ({
                ...leave,
                branchid: getBranchId(branch),
                branchcode: getBranchCode(branch),
                branchname: getBranchName(branch)
            }));

        if (newBranchLeaves.length > 0) {
            setSelectedLeaves(prev => [...prev, ...newBranchLeaves]);
        }

        setSelectedBranchCodes(prev => [...prev, branchCode]);
    };

    const fetchBranches = async () => {
        const response = await axios.get(
            baseurladdress + `findallbranches`,
            {
                headers: { Authorization: `Bearer ${accesstoken}` }
            }
        );
        setBranches(response.data.response || []);
    };

    const fetchLeaveTypes = async () => {
        const response = await axios.get(
            baseurladdress + `findallleaves`,
            {
                headers: { Authorization: `Bearer ${accesstoken}` }
            }
        );
        const active = (response.data.response || []).filter(item => item.leave_status === 1);
        setLeaveTypes(active);
    };

    const fetchAllPolicies = async () => {
        const response = await axios.get(
            baseurladdress + `findleavepolicy`,
            {
                headers: { Authorization: `Bearer ${accesstoken}` }
            }
        );
        const active = (response.data.response || []).filter(item => item.leavepolicy_status === 1);
        setLeavepolices(active);
    };

    // Get all staff belonging to selected branches
    const getStaffBySelectedBranches = () => {
        if (!staffList.length || !branchList.length || !selectedLeaves.length) return [];

        const selectedBranchIds = [...new Set(selectedLeaves.map(l => Number(l.branchid)).filter(Boolean))];

        return staffList.filter((staff) => {
            const staffBranchId = Number(staff.staff_placedat);
            return selectedBranchIds.includes(staffBranchId);
        });
    };

    const fetchLeavePolicy = async (branchesData) => {
        const response = await axios.get(
            baseurladdress + `getleavepolicybypolicynum/${leavepolicy_num}`,
            {
                headers: { Authorization: `Bearer ${accesstoken}` }
            }
        );

        const data = response.data.response || [];

        if (data.length === 0) return;

        const branchListForLookup = branchesData || branches;

        setPolicyNo(data[0].leavepolicy_num);

        setAffectedFrom(
            data[0].levpo_affectedfrom
                ? data[0].levpo_affectedfrom.substring(0, 10)
                : ''
        );

        setAffectedTo(
            data[0].levpo_affectedto
                ? data[0].levpo_affectedto.substring(0, 10)
                : ''
        );

        // Set levpo_flag from response (check first row)
        setLevpoFlag(data[0].levpo_flag === 1 || data[0].levpo_flag === '1');

        // FIX: Deduplicate by branchid + leaveid since GET API now returns
        // one row per staff member (branch+leavetype+staffid grouping)
        const branchCodes = [];
        const seen = new Set();
        const formattedLeaves = data.reduce((acc, item) => {
            const key = `${item.leavepolicy_branchid}-${item.leavepolicy_leavetypeid}`;
            if (seen.has(key)) return acc;
            seen.add(key);

            // Look up branch code from branches list using branchid
            const matchedBranch = branchListForLookup.find(
                b => Number(getBranchId(b)) === Number(item.leavepolicy_branchid)
            );
            const branchCode = getBranchCode(matchedBranch) || item.leavepolicy_branchcode || '';
            if (branchCode) {
                branchCodes.push(branchCode);
            }
            acc.push({
                leaveid: item.leavepolicy_leavetypeid,
                leave_type: item.leavepolicy_leavetype,
                max_leave: item.leavepolicy_leavealloted,
                branchid: item.leavepolicy_branchid,
                branchcode: branchCode,
                branchname: item.leavepolicy_branchname
            });
            return acc;
        }, []);

        setSelectedLeaves(formattedLeaves);

        if (branchCodes.length > 0) {
            setSelectedBranchCodes([...new Set(branchCodes)]);
        }
    };

    // Load all staff and branches for auto-assignment by branch
    useEffect(() => {
        Promise.all([
            axios.get(baseurladdress + "findallstaff", {
                headers: { Authorization: `Bearer ${accesstoken}` }
            }),
            axios.get(baseurladdress + "getallbranchs", {
                headers: { Authorization: `Bearer ${accesstoken}` }
            })
        ])
            .then(([staffRes, branchRes]) => {
                setStaffList(staffRes.data.response || []);
                setBranchList(branchRes.data.response || []);
            })
            .catch(err => console.error(err));
    }, []);


    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            try {
                // First load branches, then fetch leave policy (pass branches directly for lookup)
                const branchesRes = await axios.get(
                    baseurladdress + `findallbranches`,
                    {
                        headers: { Authorization: `Bearer ${accesstoken}` }
                    }
                );
                const branchesData = branchesRes.data.response || [];
                setBranches(branchesData);
                await Promise.all([
                    fetchLeaveTypes(),
                    fetchAllPolicies(),
                    fetchLeavePolicy(branchesData)
                ]);
            } catch (error) {
                console.error("Error loading leave policy data:", error);
                Swal.fire('Error', 'Failed to load leave policy details.', 'error');
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }, [leavepolicy_num]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (branchDropdownRef.current && !branchDropdownRef.current.contains(event.target)) {
                setIsBranchDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleDeleteByLeaveType = (leaveid) => {
        setSelectedLeaves(prev => prev.filter(leave => leave.leaveid !== leaveid));
    };

    const handleAddLeaveType = async () => {
        if (!selectedLeaveId || selectedBranchCodes.length === 0) {
            Swal.fire('Info', 'Please choose a branch and leave type.', 'info');
            return;
        }

        const leave = leaveTypes.find(item => item.leaveid === parseInt(selectedLeaveId));
        const selectedBranchList = branches.filter(branch =>
            selectedBranchCodes.includes(getBranchCode(branch))
        );

        if (!leave || selectedBranchList.length === 0) {
            Swal.fire('Error', 'Could not find selected leave type or branch.', 'error');
            return;
        }

        const alreadySelectedBranches = selectedBranchList.filter((branch) =>
            selectedLeaves.some(
                (policy) =>
                    String(policy.branchid) === String(getBranchId(branch)) &&
                    policy.leaveid === parseInt(selectedLeaveId)
            )
        );

        if (alreadySelectedBranches.length === selectedBranchList.length) {
            Swal.fire({
                icon: "warning",
                title: "Already Added",
                text: "This leave type is already added for the selected branch(es).",
                confirmButtonText: "OK"
            });
            return;
        }

        const duplicateBranches = selectedBranchList.filter((selectedBranch) =>
            leavepolices.some(policy => {
                const cleanedLeaveTypes = policy.leavepolicy_leavetype
                    .split(',')
                    .map(s => s.trim().toLowerCase());
                return (
                    policy.leavepolicy_branchname === getBranchName(selectedBranch) &&
                    cleanedLeaveTypes.includes(leave.leave_type.toLowerCase())
                );
            })
        );

        if (duplicateBranches.length > 0) {
            const result = await Swal.fire({
                title: "Duplicate Found",
                text: "Some selected branches already have this leave type in leave policies. Do you still want to add it?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, add it!",
                cancelButtonText: "No, cancel"
            });
            if (!result.isConfirmed) return;
        }

        const newLeaves = selectedBranchList
            .filter((selectedBranch) =>
                !selectedLeaves.some(
                    (policy) =>
                        String(policy.branchid) === String(getBranchId(selectedBranch)) &&
                        policy.leaveid === parseInt(selectedLeaveId)
                )
            )
            .map((selectedBranch) => ({
                ...leave,
                branchid: getBranchId(selectedBranch),
                branchcode: getBranchCode(selectedBranch),
                branchname: getBranchName(selectedBranch)
            }));

        if (newLeaves.length === 0) return;

        setSelectedLeaves(prev => [...prev, ...newLeaves]);
        setSelectedLeaveId('');
    };

    const handleSubmit = async () => {
        if (!policyno || selectedLeaves.length === 0) {
            Swal.fire('Error', 'Please keep policy number and add branch and leave type.', 'error');
            return;
        }

        setSubmitting(true);

        const dataToSend = selectedLeaves.map(leave => ({
            leavepolicy_num: policyno,
            leavepolicy_branchid: Number(leave.branchid),
            leavepolicy_branchcode: String(leave.branchcode || '').trim(),
            leavepolicy_branchname: String(leave.branchname || '').trim(),
            leavepolicy_leavetypeid: Number(leave.leaveid),
            leavepolicy_leavetype: String(leave.leave_type || '').trim(),
            leavepolicy_leavealloted: leave.max_leave,
            levpo_affectedfrom: affectedFrom,
            levpo_affectedto: affectedTo,
            levpo_flag: levpoFlag ? 1 : 0,
            levpo_staff_list: [],
            userid: accessuserid
        }));

        try {
            const response = await fetch(
                baseurladdress + `updateleavepolicy`,
                {
                    method: "POST",
                    body: JSON.stringify(dataToSend),
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            const result = await response.json();

            if (result.status === "success") {
                showToast('success', 'Leave policy updated successfully');
                navigate("/leavepolicy");
            } else {
                Swal.fire('Error', result.message || 'Failed to update', 'error');
            }
        } catch (error) {
            console.error(error);
            Swal.fire('Error', 'Something went wrong.', 'error');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div className="content-wrap">
                <div className="container-fluid">
                    <NavLink to="/leavepolicy">
                        <div style={{ display: "flex" }}>
                            <a className="float">
                                <i
                                    className="fa fa-arrow-left my-float"
                                    style={{ marginTop: "21px" }}
                                />
                            </a>
                        </div>
                    </NavLink>

                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Edit Leave Policy</h4>
                        </div>

                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-6 col-xxl-12 mt-3">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="form-row">
                                                <div className="col-sm-3">
                                                    <h6>Policy</h6>
                                                    <input
                                                        className="form-control"
                                                        value={policyno}
                                                        disabled
                                                    />
                                                </div>

                                                <div className="col-sm-4">
                                                    <h6>Branch</h6>
                                                    <div
                                                        style={branchSelectorStyles.wrapper}
                                                        ref={branchDropdownRef}
                                                    >
                                                        <div
                                                            style={branchSelectorStyles.trigger}
                                                            onClick={() => setIsBranchDropdownOpen(prev => !prev)}
                                                        >
                                                            <span style={branchSelectorStyles.triggerText}>
                                                                {getBranchTriggerText()}
                                                            </span>
                                                            <i
                                                                className={`fa ${isBranchDropdownOpen ? "fa-chevron-up" : "fa-chevron-down"}`}
                                                                style={branchSelectorStyles.triggerIcon}
                                                            />
                                                        </div>

                                                        {isBranchDropdownOpen && (
                                                            <div style={branchSelectorStyles.dropdown}>
                                                                <div style={branchSelectorStyles.header}>
                                                                    <span style={branchSelectorStyles.headerText}>Choose Branches</span>
                                                                </div>
                                                                <div style={branchSelectorStyles.list}>
                                                                    <label
                                                                        htmlFor="select-all-branches"
                                                                        style={{
                                                                            ...branchSelectorStyles.item,
                                                                            backgroundColor: branches.length > 0 && selectedBranchCodes.length === branches.length ? "#edf3ff" : "#f8faff",
                                                                            border: branches.length > 0 && selectedBranchCodes.length === branches.length ? "1px solid #bfd2ff" : "1px solid #edf1f7"
                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            id="select-all-branches"
                                                                            checked={branches.length > 0 && selectedBranchCodes.length === branches.length}
                                                                            onChange={handleSelectAllBranches}
                                                                            style={branchSelectorStyles.checkbox}
                                                                        />
                                                                        <span style={{ ...branchSelectorStyles.label, fontWeight: 700 }}>
                                                                            Select All Branches
                                                                        </span>
                                                                    </label>

                                                                    {branches.map((item) => {
                                                                        const branchCode = getBranchCode(item);
                                                                        const branchId = getBranchId(item);
                                                                        const isChecked = selectedBranchCodes.includes(branchCode);

                                                                        return (
                                                                            <label
                                                                                htmlFor={`branch-${branchId}`}
                                                                                key={`${branchId}-${branchCode}`}
                                                                                style={{
                                                                                    ...branchSelectorStyles.item,
                                                                                    backgroundColor: isChecked ? "#edf3ff" : "#ffffff",
                                                                                    border: isChecked ? "1px solid #bfd2ff" : "1px solid #edf1f7"
                                                                                }}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id={`branch-${branchId}`}
                                                                                    checked={isChecked}
                                                                                    onChange={() => handleBranchCheckboxChange(branchCode)}
                                                                                    style={branchSelectorStyles.checkbox}
                                                                                />
                                                                                <span style={branchSelectorStyles.label}>
                                                                                    {getBranchName(item)}
                                                                                </span>
                                                                            </label>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-sm-4">
                                                    <h6>Type</h6>
                                                    <select
                                                        className="form-control"
                                                        value={selectedLeaveId}
                                                        onChange={(e) => setSelectedLeaveId(e.target.value)}
                                                    >
                                                        <option value="">Choose</option>
                                                        {leaveTypes.map(item => (
                                                            <option key={item.leaveid} value={item.leaveid}>
                                                                {item.leave_type}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                {/* <button
                                                    className="btn plus-icon"
                                                    onClick={handleAddLeaveType}
                                                    disabled={!selectedLeaveId || selectedBranchCodes.length === 0}
                                                >
                                                    + Add
                                                </button> */}

                                                <button
                                                    type="button"
                                                    className="btn plus-icon"
                                                    style={{ border: "none" }}
                                                    data-tooltip-id="mytooltip"
                                                    onClick={handleAddLeaveType}
                                                    disabled={!selectedLeaveId || selectedBranchCodes.length === 0}
                                                >
                                                    <span style={{ fontSize: "1.2rem" }}>+</span>
                                                    <span style={{ fontSize: "0.7rem", marginLeft: "0.2rem", color: "black" }}>Add</span>
                                                </button>


                                            </div>

                                            <div className="form-row mt-3">
                                                <div className="col-sm-4">
                                                    <h6>Affected From</h6>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={affectedFrom}
                                                        onChange={(e) => setAffectedFrom(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-sm-4">
                                                    <h6>Affected To</h6>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={affectedTo}
                                                        onChange={(e) => setAffectedTo(e.target.value)}
                                                    />
                                                </div>

                                                {/* levpo_flag checkbox - Apply to All Staff */}
                                                <div className="col-sm-4 mt-1">
                                                    <h6>Apply to All Staff</h6>
                                                    <div className="form-check" style={{ marginTop: "12px" }}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id="editLevpoFlagCheckbox"
                                                            checked={levpoFlag}
                                                            onChange={(e) => setLevpoFlag(e.target.checked)}
                                                            style={{
                                                                width: "14px",
                                                                height: "14px",
                                                                cursor: "pointer",
                                                                accentColor: "#2f5bea"
                                                            }}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="editLevpoFlagCheckbox"
                                                            style={{
                                                                marginLeft: "8px",
                                                                cursor: "pointer",
                                                                fontSize: "0.95rem",
                                                                color: "#2f3b52"
                                                            }}
                                                        >
                                                            {levpoFlag
                                                                ? "This policy applies to all staff"
                                                                : "Check to apply this policy to all staff"
                                                            }
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 d-flex justify-content-center mt-4">

                                                <button
                                                    className="btn btn-primary mt-4"
                                                    onClick={handleSubmit}
                                                    disabled={submitting}
                                                >
                                                    {submitting ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                            Updating...
                                                        </>
                                                    ) : (
                                                        "Update"
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xl-6 col-xxl-12 mt-3">
                                    <div className="card">
                                        <div className="card-body">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Type</th>
                                                        <th>Allotted</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {groupedSelectedLeaves.length > 0
                                                        ? groupedSelectedLeaves.map(leave => (
                                                            <tr key={leave.leaveid}>
                                                                <td>{leave.leave_type}</td>
                                                                <td>{leave.max_leave}</td>
                                                                <td>
                                                                    <i
                                                                        className="fa fa-close text-danger"
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => handleDeleteByLeaveType(leave.leaveid)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))
                                                        : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center">
                                                                    No leave types added
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditLeavePolicy;